<ion-header>
  <ion-toolbar>
    <ion-row >
      <ion-col size="8" class="filterTitle">
        <ion-text class="filter-text">Filter({{ filterCount }})</ion-text>
      </ion-col>
  <ion-col class="filter-close-btn">
      <div (click)="closebtn()" >
        <ion-icon class="filter-close-btn" name="close-outline"></ion-icon>
      </div>
  </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="filter-container">
    <ion-row *ngIf="isHSEUser" class="padding_div">
      <ion-label class="shieldvisit">SHIELD visit:</ion-label>
      </ion-row>
    <ion-row *ngIf="isHSEUser">
      
      <!-- <ion-col size="4">
        <ion-chip *ngIf="isSelectedMyself" class="filter-chip" (click)="mySelf()">
          <ion-label>Myself</ion-label>
        </ion-chip>
        <ion-chip *ngIf="!isSelectedMyself" [outline]="true" class="filter-chip-unselect" (click)="mySelf()">
          <ion-label>Myself</ion-label>
        </ion-chip></ion-col>
      <ion-col size="4">
      <ion-chip *ngIf="isSelectedOtherShieldUser" class="filter-chip" (click)="otherShieldUser()">
        <ion-label>Others</ion-label>
      </ion-chip>
      <ion-chip *ngIf="!isSelectedOtherShieldUser" [outline]="true" class="filter-chip-unselect" (click)="otherShieldUser()">
        <ion-label>Others</ion-label>
      </ion-chip>
      </ion-col> -->

      <ion-col size="4">
        <ion-chip
          [outline]="!isSelectedMyself"
          [class.filter-chip]="isSelectedMyself"
          [class.filter-chip-unselect]="!isSelectedMyself"
          (click)="mySelf()"
        >
          <ion-label>Myself</ion-label>
        </ion-chip>
      </ion-col>

      <ion-col size="4">
        <ion-chip
          [outline]="!isSelectedOtherShieldUser"
          [class.filter-chip]="isSelectedOtherShieldUser"
          [class.filter-chip-unselect]="!isSelectedOtherShieldUser"
          (click)="otherShieldUser()"
        >
          <ion-label>Others</ion-label>
        </ion-chip>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="isHSEUser">
      <div class="p-10" *ngFor="let tour of colorCode" (click)="tourfilterSelected(tour)">
        <div class="key-icons">
          <img *ngIf="tour.selected" [src]="tour.activeIcon" />
          <img *ngIf="!tour.selected" [src]="tour.inActiveIcon" />
          <ion-label class="colorcodetitle">{{tour.title}}</ion-label>
          <ion-label>{{tour.desc}}</ion-label>
        </div>
      </div>
    </ion-row>
    <!-- <div class="hr"></div> -->
    <ion-row *ngIf="isHSEUser" class="padding_div">
      <ion-label class="p-tb">Housekeeping rating:</ion-label>
      </ion-row>

    <ion-row class="padding_div">
      <div class="slider-container">
        <!-- <mat-slider
          min="1"
          max="5"
          [(ngModel)]="sliderValue"
          step="1" showTickMarks discrete  [displayWith]="formatLabel"
          thumbLabel 
          (change)="onSliderChange(sliderValue.startRatingValue,sliderValue.endRatingValue)"
          range >
          <input  matSliderStartThumb  [(ngModel)]="sliderValue.startRatingValue"/>
          <input  matSliderEndThumb   [(ngModel)]="sliderValue.endRatingValue" />
        </mat-slider> -->
        <ng-container *ngIf="sliderReady">
          <mat-slider
            min="1"
            max="5"
            step="1"
            showTickMarks
            discrete
            [displayWith]="formatLabel"
            thumbLabel
            range
            (change)="onSliderChange(form.value.startRatingValue, form.value.endRatingValue)"
          >
            <input
              matSliderStartThumb
              [formControl]="form.controls.startRatingValue"
            />
            <input
              matSliderEndThumb
              [formControl]="form.controls.endRatingValue"
            />
          </mat-slider>
        </ng-container>
        <div class="slider-labels">
          <span class="start-label">1</span>
          <span class="end-label">5</span>
        </div>
      </div>
    </ion-row>
<ion-row class="segments-container">
  <ion-label class="shieldvisit">Segments:</ion-label>
</ion-row>
<ion-row class="padding_div">
  <span *ngFor="let segment of segmentsList">
    <ion-chip *ngIf="segment.selected" class="filter-chip" (click)="unSelectSegment(segment)">
      <img src="assets/img/checkin/filters/filter_checkmark.svg" alt="" class="filter-checkmark">
      <ion-label>{{ segment.abr }}</ion-label>
    </ion-chip>
    <ion-chip *ngIf="!segment.selected" class="fc1" (click)="selectSegment(segment)">
      <ion-label>{{ segment.abr }}</ion-label>
    </ion-chip>
  </span>
</ion-row>
    <ion-row class="rowBtn">
      <ion-col size="4" (click)="resetSelection()">
        <ion-chip type="button" class="resetBtnCss" >
         Reset </ion-chip>
      </ion-col>
      <ion-col size="4"  >
        <ion-chip type="button"    class="BtnCss" [disabled]="isButtonDisabled" (click)="confirmSelection()" >
          Apply</ion-chip>
      </ion-col>
    </ion-row>
   
  </div>
</ion-content>